export const state = {
	httpText: '',
	httpColor: '',
	httpIsActive: false
};

export const getters = {
	httpText: state => {
		return state.httpText;
	},
	httpColor: state => {
		return state.httpColor;
	},
	httpIsActive: state => {
		return state.httpIsActive;
	}
};

export const mutations = {
	SET_HTTP_RESPONSE (state, data) {
		state.httpText = data.text;
		state.httpColor = data.color;
		state.httpIsActive = true;
	},
	RESET_HTTP_RESPONSE (state) {
		state.httpIsActive = false;
	}
};

export const actions = {
	setHttpResponse ({ commit, dispatch }, payload) {
		commit('SET_HTTP_RESPONSE', payload);

		setTimeout(() => {
			dispatch('resetHttpResponse');
		}, payload.timeout || 3000);
	},
	resetHttpResponse ({ commit }) {
		commit('RESET_HTTP_RESPONSE');
	}
};